<template>
	<div class="row">
		<div class="col-sm-12 col-md-12 col-lg-12">
			<div class="login">
				<div class="row row-form">
					<div class="col-sm-12">
						<div class="confirmation_registration_message">
							<p>A confirmation of registration message has been sent to your inbox.</p>
						</div>

						<button class="login_button-resend" @click="resend">{{ $t('resend.confirmation.email') }}</button>

						<div class="resent_message">
							<span>Didn't receive confirmation email?</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import http from 'utils/http'
import { showMessageAlert } from '@/core/shared'

export default {
	name: 'Confirm',
	metaInfo: {
		title: 'Confirm email'
	},
	props: [
		'email'
	],
	methods: {
		resend: function () {
			http.post('auth/resend-confirmation-email', {email: this.email})
			.then(() => {
				showMessageAlert('Resent confirmation', 'success')
			})
			.catch(error => console.log(error))
		}
	}
}
</script>

<style scoped>

</style>
